// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  font-size: 28px;
}

tr.topMenu td {
  height: 32px;
}

.noRightBorder {
  border-right: none;
}

.topHead {
  height: 70px;
}

::ng-deep .ng-sidebar {
  z-index: 101 !important;
}

ng-sidebar-container ::ng-deep .ng-sidebar__backdrop {
  background: #fff;
  opacity: 0;
}

.slidingSidebar {
  height: 100vh;
  width: 400px;
  background-color: #EDF2F5;
  padding: 25px;
}

#typeMenu {
  position: relative;
  top: 13px;
}

.clickMode {
  background-color: #EDF2F5;
}

#typeMenu div {
  padding: 0 3px;
}

#typeMenu div div {
  margin: auto;
  text-align: center;
  cursor: pointer;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

#subMenu {
  margin-top: 0.88cm;
  margin-left: 0;
  margin-right: 0;
  border-bottom: 1px solid rgb(218, 218, 218);
  height: 37px;
}

.typeSelected {
  border-bottom: 5px solid #007566;
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  margin: 27px -11px;
  border: 1px solid #EDF2F5;
  background-color: white;
  min-width: 160px;
  z-index: 1;
}

/* Links inside the dropdown */
.dropdown-content a {
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
  display: block;
}

/* Change the background color of the dropdown button when the dropdown content is shown */
.dropdown:hover .dropbtn {
  background-color: #3e8e41;
}

app-main-list-search-bar ::ng-deep .filterButton {
  display: none;
}

ngx-loading ::ng-deep div.backdrop {
  top: 192px;
}

ngx-loading ::ng-deep div div.spinner-three-bounce {
  position: fixed;
  z-index: 999;
}

.subTitle {
  font-family: "MontserratRegular", sans-serif;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.4em;
  padding: 0 0 0.35em 0;
  margin-top: -11px;
  background-color: #EDF2F5;
}

app-main-list ::ng-deep .ng-sidebar__content {
  position: static !important;
  padding-left: 15px !important;
}

/**
#listWrap {
    position: absolute;
    top: 160px;
}
 */
app-main-list ::ng-deep div div table#mainList thead tr th:first-child,
app-main-list ::ng-deep div div table#mainList tbody tr td:first-child {
  min-width: 20% !important;
  padding-left: 15px !important;
}

app-main-list ::ng-deep div div table#mainList thead tr th:nth-child(2),
app-main-list ::ng-deep div div table#mainList tbody tr td:nth-child(2) {
  width: 182px !important;
  padding-left: 15px !important;
}

app-main-list ::ng-deep div div table#mainList thead tr th:nth-child(3),
app-main-list ::ng-deep div div table#mainList tbody tr td:nth-child(3) {
  width: 200px !important;
  padding-left: 15px !important;
}

app-main-list ::ng-deep div div table#mainList thead tr th:nth-child(4),
app-main-list ::ng-deep div div table#mainList thead tr th:nth-child(5),
app-main-list ::ng-deep div div table#mainList tbody tr td:nth-child(4),
app-main-list ::ng-deep div div table#mainList tbody tr td:nth-child(5) {
  width: 110px !important;
  padding-left: 15px !important;
}

app-main-list ::ng-deep div div table#mainList thead tr th:nth-child(6),
app-main-list ::ng-deep div div table#mainList thead tr th:nth-child(7),
app-main-list ::ng-deep div div table#mainList thead tr th:nth-child(8),
app-main-list ::ng-deep div div table#mainList tbody tr td:nth-child(6),
app-main-list ::ng-deep div div table#mainList tbody tr td:nth-child(7),
app-main-list ::ng-deep div div table#mainList tbody tr td:nth-child(8) {
  width: 95px !important;
  padding-left: 15px !important;
}

/**
app-main-list ::ng-deep div div table#mainList thead tr th:nth-child(7) div {
    padding-left: 9px !important;
}
app-main-list ::ng-deep div div table#mainList thead tr th:nth-child(8) div {
    padding-left: 3px !important;
}*/
#topMenuWrapper {
  padding: 28px 28px 0 28px;
  background-color: white;
  z-index: 99;
  min-width: 610px;
  height: 160px;
}

ng-sidebar ::ng-deep aside {
  z-index: 100 !important;
}

.margin-for-container {
  margin-top: 1.3em;
}

.radioAdmin {
  margin: auto 7px auto 15px;
}

.firstRadioAdmin {
  margin-left: auto;
}

.radio-container {
  margin-top: 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/administration/components/administration-list/administration-list.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,UAAA;AACJ;;AAEA;EACI,aAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;AACJ;;AAEA;EACI,kBAAA;EACA,SAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,YAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,WAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,2CAAA;EACA,YAAA;AACJ;;AAEA;EACI,gCAAA;AACJ;;AAEA,kEAAA;AACA;EACI,kBAAA;EACA,qBAAA;AACJ;;AAEA,yCAAA;AACA;EACI,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;AACJ;;AAEA,8BAAA;AACA;EACI,kBAAA;EACA,qBAAA;EACA,cAAA;AACJ;;AAEA,oCAAA;AACA;EACI,cAAA;AACJ;;AAEA,0FAAA;AACA;EACI,yBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,eAAA;EACA,YAAA;AACJ;;AAEA;EACI,4CAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,yBAAA;AACJ;;AAEA;EACI,2BAAA;EACA,6BAAA;AACJ;;AACA;;;;;EAAA;AAOA;;EAEI,yBAAA;EACA,6BAAA;AACJ;;AAEA;;EAEI,uBAAA;EACA,6BAAA;AACJ;;AAEA;;EAGI,uBAAA;EACA,6BAAA;AAAJ;;AAGA;;;;EAKI,uBAAA;EACA,6BAAA;AADJ;;AAIA;;;;;;EAOI,sBAAA;EACA,6BAAA;AAFJ;;AAIA;;;;;;EAAA;AASA;EACI,yBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AAHJ;;AAOA;EACI,uBAAA;AAJJ;;AAOA;EACI,iBAAA;AAJJ;;AAOA;EACI,0BAAA;AAJJ;;AAOA;EACI,iBAAA;AAJJ;;AAOA;EACI,eAAA;AAJJ","sourcesContent":["h1 {\n    font-size: 28px;\n}\n\ntr.topMenu td {\n    height: 32px;\n}\n\n.noRightBorder {\n    border-right: none;\n}\n\n.topHead {\n    height: 70px;\n}\n\n::ng-deep .ng-sidebar {\n    z-index: 101 !important;\n}\n\nng-sidebar-container ::ng-deep .ng-sidebar__backdrop {\n    background: #fff;\n    opacity: 0;\n}\n\n.slidingSidebar {\n    height: 100vh;\n    width: 400px;\n    background-color: #EDF2F5;\n    padding: 25px;\n}\n\n#typeMenu {\n    position: relative;\n    top: 13px\n}\n\n.clickMode {\n    background-color: #EDF2F5;\n}\n\n#typeMenu div {\n    padding: 0 3px;\n}\n\n#typeMenu div div {\n    margin: auto;\n    text-align: center;\n    cursor: pointer;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n}\n\n#subMenu {\n    margin-top: .88cm;\n    margin-left: 0;\n    margin-right: 0;\n    border-bottom: 1px solid rgb(218, 218, 218);\n    height: 37px;\n}\n\n.typeSelected {\n    border-bottom: 5px solid #007566\n}\n\n/* The container <div> - needed to position the dropdown content */\n.dropdown {\n    position: relative;\n    display: inline-block;\n}\n\n/* Dropdown Content (Hidden by Default) */\n.dropdown-content {\n    display: none;\n    position: absolute;\n    margin: 27px -11px;\n    border: 1px solid #EDF2F5;\n    background-color: white;\n    min-width: 160px;\n    z-index: 1;\n}\n\n/* Links inside the dropdown */\n.dropdown-content a {\n    padding: 12px 16px;\n    text-decoration: none;\n    display: block;\n}\n\n/* Show the dropdown menu on hover */\n.dropdown:hover .dropdown-content {\n    display: block;\n}\n\n/* Change the background color of the dropdown button when the dropdown content is shown */\n.dropdown:hover .dropbtn {\n    background-color: #3e8e41;\n}\n\napp-main-list-search-bar ::ng-deep .filterButton {\n    display: none;\n}\n\nngx-loading ::ng-deep div.backdrop {\n    top: 192px;\n}\n\nngx-loading ::ng-deep div div.spinner-three-bounce {\n    position: fixed;\n    z-index: 999;\n}\n\n.subTitle {\n    font-family: 'MontserratRegular',  sans-serif;\n    font-size: 14px;\n    font-weight: normal;\n    line-height: 1.4em;\n    padding: 0 0 0.35em 0;\n    margin-top: -11px;\n    background-color: #EDF2F5;\n}\n\napp-main-list ::ng-deep .ng-sidebar__content {\n    position: static !important;\n    padding-left: 15px !important;\n}\n/**\n#listWrap {\n    position: absolute;\n    top: 160px;\n}\n */\n\napp-main-list ::ng-deep div div table#mainList thead tr th:first-child,\napp-main-list ::ng-deep div div table#mainList tbody tr td:first-child,{\n    min-width: 20% !important;\n    padding-left: 15px !important;\n}\n\napp-main-list ::ng-deep div div table#mainList thead tr th:nth-child(2),\napp-main-list ::ng-deep div div table#mainList tbody tr td:nth-child(2){\n    width: 182px !important;\n    padding-left: 15px !important;\n}\n\napp-main-list ::ng-deep div div table#mainList thead tr th:nth-child(3),\napp-main-list ::ng-deep div div table#mainList tbody tr td:nth-child(3),\n{\n    width: 200px !important;\n    padding-left: 15px !important;\n}\n\napp-main-list ::ng-deep div div table#mainList thead tr th:nth-child(4),\napp-main-list ::ng-deep div div table#mainList thead tr th:nth-child(5),\napp-main-list ::ng-deep div div table#mainList tbody tr td:nth-child(4),\napp-main-list ::ng-deep div div table#mainList tbody tr td:nth-child(5)\n{\n    width: 110px !important;\n    padding-left: 15px !important;\n}\n\napp-main-list ::ng-deep div div table#mainList thead tr th:nth-child(6),\napp-main-list ::ng-deep div div table#mainList thead tr th:nth-child(7),\napp-main-list ::ng-deep div div table#mainList thead tr th:nth-child(8),\napp-main-list ::ng-deep div div table#mainList tbody tr td:nth-child(6),\napp-main-list ::ng-deep div div table#mainList tbody tr td:nth-child(7),\napp-main-list ::ng-deep div div table#mainList tbody tr td:nth-child(8)\n{\n    width: 95px !important;\n    padding-left: 15px !important;\n}\n/**\napp-main-list ::ng-deep div div table#mainList thead tr th:nth-child(7) div {\n    padding-left: 9px !important;\n}\napp-main-list ::ng-deep div div table#mainList thead tr th:nth-child(8) div {\n    padding-left: 3px !important;\n}*/\n\n\n#topMenuWrapper {\n    padding: 28px 28px 0 28px;\n    background-color: white;\n    z-index: 99;\n    min-width: 610px;\n    height: 160px;\n\n}\n\nng-sidebar ::ng-deep aside {\n    z-index: 100 !important;\n}\n\n.margin-for-container {\n    margin-top: 1.3em\n}\n\n.radioAdmin {\n    margin: auto 7px auto 15px;\n}\n\n.firstRadioAdmin {\n    margin-left: auto;\n}\n\n.radio-container {\n    margin-top: 2px;\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
